import { StyleSheet } from 'react-native';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { neutrals } from 'src/theme/colors';

export const stylesShared = StyleSheet.create({
  buttonText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
  },
  subButtonText: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 16,
    color: neutrals.white,
    textAlign: 'center',
  },
  textAbsoluteContainer: {
    position: 'absolute',
    flexDirection: 'row',
    left: 26,
    bottom: 32,
    gap: 8,
    alignItems: 'center',
  },
  textAbsolute: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 20,
  },
});

export const stylesDesktop = StyleSheet.create({
  ...stylesShared,
  title: {
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 28,
    textAlign: 'center',
    marginBottom: 16,
  },
  buttonContainer: {
    position: 'absolute',
    right: 32,
    bottom: 32,
  },
  button: {
    width: 327,
  },
});

export const stylesMobile = StyleSheet.create({
  ...stylesShared,
  title: {
    ...textLatoStyleDS.TitleBoldXl,
    textAlign: 'center',
  },
  buttonContainer: {
    position: 'absolute',
    bottom: 32,
    height: 60,
  },
  button: {
    width: 337,
  },
});
